import { Container } from "react-bootstrap";
import Header from "../../components/Header/category";
import TeamBlock from "../../components/Home/team";
import LeistungenBlock from "../../components/Home/leistungen";
import ReferalBlock from "../../components/Home/referal";
import AditionalBlock from "../../components/Content/aditional";
import OffersBlock from "../../components/Content/offer";
import PREISE_QUERY from "../../queries/preise";
import Query from "../../components/Query";
import FAQ from "../../components/Faq";

const Preise = () => {
  return (
    <Query query={PREISE_QUERY} id={null}>
      {({ data: { preise } }) => {
        const data = preise.data.attributes;
        return (
          <>
            <header className="layout layout__min layout__bg layout__bg_primary position-relative overflow-hidden">
              <Container fluid>
                <Header props={data.header} />
              </Container>
            </header>
            <main>
              <section className="layout layout__color_primary">
                <Container fluid>
                  {(data.pricelists.pdf1?.data?.attributes?.url ||
                    data.pricelists.pdf6?.data?.attributes?.url) && (
                    <div className="d-flex flex-column flex-sm-row w-100 justify-content-center gap-3 gap-md-4 gap-lg-5 mx-auto mb-3 mb-md-4 mb-lg-5">
                      {data.pricelists.pdf1?.data?.attributes?.url && (
                        <div data-aos="fade-up">
                          <a
                            href={
                              process.env.REACT_APP_BACKEND_URL +
                              data.pricelists.pdf1.data.attributes.url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn__big btn__border btn__border_primary"
                          >
                            {data.pricelists.titleaklasse}
                          </a>
                        </div>
                      )}
                      {data.pricelists.pdf6?.data?.attributes?.url && (
                        <div data-aos="fade-up">
                          <a
                            href={
                              process.env.REACT_APP_BACKEND_URL +
                              data.pricelists.pdf6.data.attributes.url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn__big btn__border btn__border_primary"
                          >
                            {data.pricelists.titleintensiva}
                          </a>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="d-flex flex-column flex-sm-row w-100 justify-content-center gap-3 gap-md-4 gap-lg-5 mx-auto ">
                    <div data-aos="fade-up">
                      <a
                        href={
                          process.env.REACT_APP_BACKEND_URL +
                          data.pricelists.pdf2.data.attributes.url
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn__big btn__border btn__border_primary"
                      >
                        {data.pricelists.titleb}
                      </a>
                    </div>
                    <div data-aos="fade-up">
                      <a
                        href={
                          process.env.REACT_APP_BACKEND_URL +
                          data.pricelists.pdf3.data.attributes.url
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn__big btn__border btn__border_primary"
                      >
                        {data.pricelists.titlebe}
                      </a>
                    </div>
                  </div>
                  {(data.pricelists.pdf4?.data?.attributes?.url ||
                    data.pricelists.pdf5?.data?.attributes?.url) && (
                    <div className="d-flex flex-column flex-sm-row w-100 justify-content-center gap-3 gap-md-4 gap-lg-5 mx-auto mt-3 mt-md-4 mt-lg-5">
                      {data.pricelists.pdf4?.data?.attributes?.url && (
                        <div data-aos="fade-up">
                          <a
                            href={
                              process.env.REACT_APP_BACKEND_URL +
                              data.pricelists.pdf4.data.attributes.url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn__big btn__border btn__border_primary"
                          >
                            {data.pricelists.titleintensivb}
                          </a>
                        </div>
                      )}
                      {data.pricelists.pdf5?.data?.attributes?.url && (
                        <div data-aos="fade-up">
                          <a
                            href={
                              process.env.REACT_APP_BACKEND_URL +
                              data.pricelists.pdf5.data.attributes.url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn__big btn__border btn__border_primary"
                          >
                            {data.pricelists.titlefremdsprachenb}
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </Container>
              </section>
              <ReferalBlock
                title={data.mainpromo.title}
                desc={data.mainpromo.info}
                img={
                  process.env.REACT_APP_BACKEND_URL +
                  data.mainpromo.img.data.attributes.url
                }
              />
              {data.offers.length > 0 && <OffersBlock offers={data.offers} />}
              <AditionalBlock aditional={data.promo} />
              <LeistungenBlock />
              <TeamBlock />
              <section className="layout layout__color_primary">
                <Container fluid>
                  <h2 data-aos="fade-up" className="">
                    FAQ
                  </h2>
                  <h2 data-aos="fade-up" className="">
                    {data.faq.title}
                  </h2>
                  <FAQ elements={data.faq.qa}></FAQ>
                </Container>
              </section>
            </main>
          </>
        );
      }}
    </Query>
  );
};

export default Preise;
